/* unplugin-vue-components disabled */import script from "./Ksiosminigame.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ksiosminigame.vue?vue&type=script&setup=true&lang=ts"

import "./Ksiosminigame.vue?vue&type=style&index=0&id=79bcee5a&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79bcee5a"]])

export default __exports__